import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface RoadWidthDialogProps {
  open: boolean;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
}

// Change a road's width anytime — applies either to the road currently being
// drawn or to a specific queued pending route, discriminated by the caller.
export function RoadWidthDialog({
  open,
  value,
  onChange,
  onClose,
  onSave,
}: RoadWidthDialogProps): JSX.Element {
  const { t } = useTranslation();
  const parsed = parseFloat(value);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        {t('roads_importer_width_dialog_title')}
      </DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}
      >
        <TextField
          autoFocus
          size="small"
          type="number"
          label={t('roads_importer_field_road_width')}
          value={value}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={onClose}
          sx={{ borderRadius: '8px', fontWeight: 600 }}
        >
          {t('roads_importer_btn_cancel')}
        </Button>
        <Button
          variant="contained"
          size="small"
          startIcon={<CheckIcon />}
          disabled={!isFinite(parsed) || parsed <= 0}
          onClick={onSave}
          sx={{ borderRadius: '8px', fontWeight: 600 }}
        >
          {t('roads_importer_btn_save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
